<div class="pdf-button" *ngIf="hasDataAvailable">
  <button mat-raised-button color="accent" (click)="downloadAsPdf()" [disabled]="isLoading">
    {{ "InspectionResult.DownloadAsPDF" | i18next }}
  </button>
</div>
<div class="mt-2" *ngIf="!hasDataAvailable">
  {{ "InspectionResult.Tabs.GalleryOverview.NoDataAvailable" | i18next }}
</div>
